// InputLabel component override
export default function InputLabel(theme: any) {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.text.primary,
          fontSize: '0.875rem',
          fontWeight: 500
        }
      }
    }
  };
}
